import ClientWebSocketWrapper from "./ClientWebSocketWrapper";
import { writable } from "svelte/store";

const API_HOST = "crosswars-dev.jevakallio.workers.dev";
const API_URL = `${API_HOST}/api/session`;

export default class GameSession {
  constructor(id) {
    this.id = id;
    this.grid = writable({});
    this.answers = writable([]);
    this.players = writable({});
    this.token = this.getPlayerToken();
    this.connection = null;
  }

  static async createSession(grid) {
    const request = JSON.stringify({ grid });
    const response = await fetch(`https://${API_URL}`, {
      method: "POST",
      body: request,
    });
    const body = await response.json();
    return body.id;
  }

  getPlayerToken() {
    let token = window.sessionStorage.getItem("crosswars_token");
    if (!token) {
      window.sessionStorage.setItem(
        "crosswars_token",
        (token = window.crypto
          .getRandomValues(new Uint32Array(1))[0]
          .toString(16))
      );
    }

    return token;
  }

  connect(id) {
    // connect
    const socket = new WebSocket(`wss://${API_URL}/${id}/connect?token=${this.token}`);
    const connection = new ClientWebSocketWrapper(socket);

    // setup event handlers
    this.connection = connection;

    return new Promise((resolve, reject) => {
      // low-level socket events
      connection.on("open", () => console.log("Connection established."));
      connection.on("close", () => console.error("Connection lost."));
      connection.on("error", (error) => {
        console.error("Failed to connect.", error);
        reject(error);
      });

      // game events
      connection.on("INITIAL_STATE", (state) => {
        this._onReceiveInitialState(state);
        resolve(this);
      });

      connection.on("SET_VALUE", (payload) => this._onReceiveValue(payload));
      connection.on("MOVE", (payload) => this._onReceivePosition(payload));
      connection.on("JOIN_GAME", (payload) => this._onPlayerJoined(payload));
      connection.on("LEAVE_GAME", (payload) => this._onPlayerLeft(payload));
    });
  }

  async sendValue({ index, value, position }) {
    this.answers.update((answers) => {
      answers[index] = value;
      return answers;
    });

    this.connection.send("SET_VALUE", {
      index,
      value,
      position: {
        index: position.index,
        direction: position.direction,
      },
    });
  }

  async sendPosition({ index, direction }) {
    // @TODO throttle?
    this.connection.send("MOVE", {
      index,
      direction,
    });
  }

  _onReceiveValue({ index, value, position }) {
    console.log("Received value from network", { index, value, position });
    this.answers.update((answers) => {
      answers[index] = value;
      return answers;
    });

    this._onReceivePosition(position);
  }

  _onReceivePosition({ player, index, direction }) {
    this.players.update((players) => {
      if (players[player]) {
        players[player] = {
          ...players[player],
          position: {
            index,
            direction,
          },
        };
      }

      return players;
    });
  }

  _onReceiveInitialState(state) {
    console.log("Received initial state", state);
    this.grid.set(state.grid);
    this.answers.set(state.answers);
    this.players.set(state.players);
  }

  _onPlayerJoined(player) {
    this.players.update((players) => {
      players[player.id] = player;
      return players;
    });
  }

  _onPlayerLeft(player) {
    this.players.update((players) => {
      delete players[player.id];
      return players;
    });
  }
}
